import enquire from 'enquire.js'
import Component from '../core/Component'
import { queries } from '../core/config'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'
import Scroll, { disableScroll, enableScroll } from '../services/Scroll'

const STATES = {
    OPEN: 'is-open',
}

export default class PopupNav extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            header: null,
            inner: null
        }

        this.categories = [...this.element.querySelectorAll('[data-category]')].map(element => ({
            element,
            categoryId: element.dataset.category,
            backCategoryId: element.dataset.categoryBack,
            backText: element.dataset.categoryBackText,
        }))

        this.lastCaller = null
        this.lastCategoryId = null
        this.timer = null

        this.desktopHandler = {
            match: () => this.attachDesktop(),
            unmatch: () => this.detachDesktop()
        }
    }

    prepare() {
        enquire.register(queries.largeUp, this.desktopHandler)
        EventBus.on(EVENTS.POPUPNAV_SETCATEGORY, this.handlePopupNavSetCategory)
        EventBus.on(EVENTS.POPUPNAV_TOGGLE, this.handlePopupNavToggle)
        EventBus.on(EVENTS.POPUPNAV_OPEN, this.handlePopupNavOpen)
        EventBus.on(EVENTS.POPUPNAV_CLOSE, this.handlePopupNavClose)
    }

    destroy() {
        clearTimeout(this.timer)
        enquire.unregister(queries.largeUp, this.desktopHandler)
        EventBus.off(EVENTS.POPUPNAV_SETCATEGORY, this.handlePopupNavSetCategory)
        EventBus.off(EVENTS.POPUPNAV_TOGGLE, this.handlePopupNavToggle)
        EventBus.off(EVENTS.POPUPNAV_OPEN, this.handlePopupNavOpen)
        EventBus.off(EVENTS.POPUPNAV_CLOSE, this.handlePopupNavClose)
    }

    attachDesktop() {
        this.ref.inner.addEventListener('mouseover', this.handleDesktopMouseOver)
        this.ref.inner.addEventListener('mouseleave', this.handleDesktopMouseLeave)
        if (this.is(STATES.OPEN)) {
            disableScroll()
        }
        this.isDesktop = true
    }

    detachDesktop() {
        this.ref.inner.removeEventListener('mouseover', this.handleDesktopMouseOver)
        this.ref.inner.removeEventListener('mouseleave', this.handleDesktopMouseLeave)
        enableScroll()
        this.isDesktop = false
    }

    handleScroll = () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.updatePositionAndDimensionsImmediately()
            })
        })
    }

    handlePopupNavToggle = () => {
        this.toggle()
    }

    handlePopupNavOpen = (options) => {
        this.open(options)
    }

    handlePopupNavClose = () => {
        this.close()
    }

    handlePopupNavSetCategory = ({ categoryId }) => {
        this.setCategory(categoryId)
    }

    handleDesktopMouseOver = () => {
        this.open({
            caller: this.lastCaller
        })
    }

    handleDesktopMouseLeave = () => {
        this.closeImmediately()
    }

    //nastavit is-active na kategorii + vsechny, ktery sou nadrazeny (resp. vsechny .backCategoryId)
    setCategory(categoryId) {
        if (this.lastCategoryId === categoryId) {
            return
        }

        const getSupercategories = (category, supercategories = []) => {
            if (!category.backCategoryId) {
                return supercategories
            }

            const backCategory = this.categories.find(_category => _category.categoryId === category.backCategoryId)
            if (backCategory) {
                supercategories.push(backCategory)
            }
            return getSupercategories(backCategory, supercategories)
        }

        const activeCategories = []
        this.categories.forEach(category => {
            if (categoryId && category.categoryId === categoryId) {
                category.element.classList.add('is-active')
                activeCategories.push(category)
            } else {
                category.element.classList.remove('is-active')
            }
            category.element.classList.remove('is-super')
        })
        activeCategories.forEach(activeCategory => {
            const supercategories = getSupercategories(activeCategory)
            supercategories.forEach(superCategory => {
                superCategory.element.classList.add('is-active', 'is-super')
            })
        })

        this.lastCategoryId = categoryId
        this.updatePositionAndDimensionsImmediately()
        this.updateHeader()
        EventBus.emit(EVENTS.POPUPNAV_CATEGORYCHANGED, { categoryId })
    }

    updateHeader() {
        const category = this.categories.find(category => category.categoryId === this.lastCategoryId)
        if (!category) {
            return
        }
        const content = category.backCategoryId ? `<button data-popupnav-category="${category.backCategoryId}">${category.backText}</button>` : ``
        this.ref.header.innerHTML = content
        document.documentElement.classList.toggle('has-popup-header', !!content)
    }

    updatePositionAndDimensionsImmediately() {
        const category = this.categories.find(category => category.categoryId === this.lastCategoryId)
        if (!category || !this.lastCaller) {
            return
        }

        //vyska + top na celym konteineru
        const callerRect = this.lastCaller.getBoundingClientRect()
        const top = callerRect.top + callerRect.height
        const height = Math.min(category.element.scrollHeight, window.innerHeight - top)
        this.element.style.top = `${top}px`
        this.element.style.height = `${height}px`

        //left pouze inner element
        const categoryRect = category.element.getBoundingClientRect()
        let categoryLeft = 0
        if (this.lastCategoryId === 'popupnav-services') {
            categoryLeft = callerRect.left + (callerRect.width / 2) - (categoryRect.width / 2)
        }
        category.element.style.left = `${categoryLeft}px`
    }

    open(options) {
        const wasOpen = this.is(STATES.OPEN)
        this.lastCaller = options?.caller
        clearTimeout(this.timer)
        this.timer = null
        this.element.classList.add(STATES.OPEN)
        this.updatePositionAndDimensionsImmediately()

        if (wasOpen) {
            return
        }
        EventBus.emit(EVENTS.POPUPNAV_OPENED)
        if (!this.isDesktop) {
            disableScroll()
        }
        Scroll.on('scroll', this.handleScroll)
    }

    close() {
        if (this.timer) {
            return
        }

        this.timer = setTimeout(() => {
            this.closeImmediately()
            this.timer = null
        }, 1000)
    }

    toggle() {
        if (!this.is(STATES.OPEN) || this.timer) {
            this.open()
        } else {
            this.closeImmediately()
        }
    }

    closeImmediately() {
        clearTimeout(this.timer)
        this.timer = null

        this.element.classList.remove(STATES.OPEN)
        EventBus.emit(EVENTS.POPUPNAV_CLOSED)

        if (!this.isDesktop) {
            enableScroll()
        }

        Scroll.off('scroll', this.handleScroll)
    }
}